var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center"},[_vm._v("You have reached this page by accident, please check the url.")])}
var staticRenderFns = []

export { render, staticRenderFns }